<template>
  <div class="infoscreen-container">
    <TicketPortrait
      v-if="tempTicket"
      ref="tempTicket"
      :style="{ display: showTempTicket ? 'flex' : 'none' }"
      :ticket="tempTicket"
    />
    <div
      v-for="(item, index) in currentItems"
      :key="item ? item.id : -(index + 1)"
      class="infoscreen-item"
      :style="{backgroundColor: $store.infoscreenData.infoboardBackgroundColor}"
    >
      <TicketPortrait
        v-if="item"
        ref="ticketRef"
        :ticket="item"
      />
    </div>
  </div>
</template>

<script>
import TicketPortrait from '../tickets/TicketPortrait';
import TemplateMixin from '../../mixins/TemplateMixin';

export default {
  name: 'TemplatePortraitNew',
  components: {
    TicketPortrait
  },
  mixins: [TemplateMixin],
  computed: {
    currentItems() {
      return this.getCurrentTickets(5);
    }
  }
}
</script>

<style lang="scss" scoped>
.infoscreen-container {
  --ticket-gap: 2px;
  display: grid;
  grid-template-rows: repeat(5, 1fr);
  gap: var(--ticket-gap);
  height: 100%;

  .infoscreen-item {
    width: 100%;
    padding: 0 5.5vw;
    border-radius: 20px;
    overflow: hidden;
  }
}
</style>
